import { EMAIL_REGEX, LOGIN_OTP_LENGTH } from "./login.constants";
import { LoginFormErrors } from "./login.types";

export const validateLoginEmail = (email: string): LoginFormErrors => {
    const errors: LoginFormErrors = {};
    const trimmed = email.trim();

    if (!trimmed) {
        errors.email = "Email is required.";
    } else if (!EMAIL_REGEX.test(trimmed)) {
        errors.email = "Please enter a valid email address.";
    }

    return errors;
};

export const validateLoginOtp = (otp: string): LoginFormErrors => {
    const errors: LoginFormErrors = {};
    const digits = otp.replace(/\D/g, "");

    if (!digits) {
        errors.otp = "Verification code is required.";
    } else if (digits.length !== LOGIN_OTP_LENGTH) {
        errors.otp = `Please enter the ${LOGIN_OTP_LENGTH}-digit verification code.`;
    }

    return errors;
};
